<div id="app" class="h-100 app"
     [ngClass]="settings.theme"
     [class.main-toolbar-fixed]="settings.mainToolbarFixed"
     [dir]="(settings.rtl) ? 'rtl' : 'ltr'">
  <router-outlet></router-outlet>
</div>

